import { Component, OnInit, Input } from '@angular/core';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-cielo-nav',
  templateUrl: './cielo-nav.component.html',
  styleUrls: ['./cielo-nav.component.scss']
})
export class CieloNavComponent implements OnInit {

  @Input() scope;
  faEllipsisV = faEllipsisV;
  constructor() { }

  ngOnInit(): void {
  }

}
